import { Navigate, useLocation } from "react-router-dom";

import { NEW_CASE_PATH } from "../../caseIde/routes";

/** The retired `/new-case` path, kept so old links and bookmarks still work. */
export const NewCaseRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`${NEW_CASE_PATH}${search}`} replace />;
};
